import * as React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from "./components/App"
import { store } from './redux/store'

export function FilterAppInit(rootElement: HTMLElement) {
    const root = createRoot(rootElement); 
    
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <App blockId={rootElement.getAttribute("data-block-id")} />
            </Provider>
        </React.StrictMode>,
    )
}
